import { FC, memo } from 'react'
import { ReactComponent as HelpIcon } from '@/assets/icons/help.svg'
import { ReactComponent as CopyIcon } from '@/assets/icons/copy.svg'
import styles from './index.module.scss'
import { useTranslation } from '@/services/i18n'
import { HOW_TO_USE_WEB3 } from '@/constants/link'
import { copyTextToClipboard } from '@/utils/clipboard'
import { AssertUrl } from '@/services/apis/address/models'

interface OverviewProps {
  address: string
  walletName: string
  assertUrls?: AssertUrl[]
}

const Overview: FC<OverviewProps> = ({ address, walletName, assertUrls }) => {
  const { t } = useTranslation()
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.name}>
          {walletName} ({t('wallet.web3Detail.nameSuffix')})
        </div>
        <a className={styles.help} target="_blank" rel="noreferrer" href={HOW_TO_USE_WEB3}>
          <span>{t('wallet.web3Detail.usageTip')}</span>
          <HelpIcon />
        </a>
      </div>
      <div className={styles.address}>
        {address}
        {address && (
          <CopyIcon
            className="cursor-pointer"
            onClick={() => {
              const success = copyTextToClipboard(address)
              if (success) {
                window.shMessage.success(t('clipboard.copySuccess'))
              }
            }}
          />
        )}
      </div>
      <div className={styles.footer}>
        <span>{t('wallet.web3Detail.boardTip')}</span>
        <div className={styles.banks}>
          {assertUrls?.map?.(assert => (
            <div className={styles.bank} key={assert.url}>
              <img src={assert.logo} alt="" />
              <a
                className={styles.bankName}
                href={assert.url.replace('{address}', address)}
                target="_blank"
                rel="noreferrer"
              >
                {assert.name}
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default memo(Overview)
